// extracted by mini-css-extract-plugin
export default {"floatingwaWrapper":"FloatingWa_floatingwaWrapper__osbB4"};